import styled from 'styled-components';
import {getToken, getSpacing} from '@tickchak/react-share/app';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import {dFlexColumn} from '../../globalVariables/GlobalFlex';
import {variableDropdown} from '../variableDropdown/VariableDropdown.css';

export const wrapper = styled.div`
    position: relative;
    border: 2px solid ${getToken('color.brand.main')};
    border-radius: var(--border-radius-border-radius-2xl);
    padding: ${getSpacing('spaceLg')};
    ${mobileMedia} {
        padding: ${getSpacing('spaceMd')};
    }
    ${p => (p.theme?.rtl && p.theme.direction === 'ltr') || (!p.theme?.rtl && p.theme.direction === 'rtl') ? 'direction: ltr;' : 'direction: rtl;'};
    ${variableDropdown}{
        inset-inline-start: unset;
        inset-inline-end: ${getSpacing('spaceLg')};
        top: ${getSpacing('spaceLg')};
        ${mobileMedia} {
            top: ${getSpacing('spaceMd')};
            inset-inline-end: ${getSpacing('spaceMd')};
        }
    }
`;

export const paragraphsContainer = styled.div`
    flex: 1;
    ${dFlexColumn};
`;
